// $(document).ready(function () {
// 	// HEADER AJAX CONTROLS
// 	$(document).on('click','.AXopen_header', function() {
// 		var obj = $(this);
// 		var open = $(this).data('open');

// 		if($('.header_content').is(':visible')) {
// 			$('body').removeClass('opened_header');
// 		}

// 		$.post(base_url + 'ajax-header-content', {open: open}, function (response){
// 			if(response != ''){
// 				$('.header_content').html(response);
// 			}
// 		}).done(function() {
// 			$('body').addClass('opened_header');
// 		});
// 	});

// 	// PAGE AJAX CONTROLS 
// 	$(document).on('click','.AXopen', function() {
// 		var open = $(this).data('open');
// 		$.post(base_url + 'ajax-page-open', {open: open}, function (response){
// 			if(response != ''){
// 				$('#JScontent').html(response);
// 				var new_url = base_url+open;
// 				window.history.pushState({}, '', new_url);
// 				$('body').removeClass('opened_header').done(function() {
// 					$('.header_content').html('');
// 				});
// 			}
// 		});
// 	});

// 	// CATEGORIES AJAX CONTROLS
// 	$(document).on('click','.AXcategory',function() {
// 		var grupa = $(this),
// 		naziv = grupa.data('grupa'),
// 		grupa_pr_id = grupa.data('grupa_pr_id'),
// 		parrent_grupa_pr_id = grupa.data('parrent_grupa_pr_id');
// 		$.post(base_url + 'ajax-categories', {grupa: naziv, grupa_pr_id: grupa_pr_id, parrent_grupa_pr_id: parrent_grupa_pr_id}, function (response){
// 			if(response != '') {
// 				$('.header_content').html(response);			
// 			}
// 		})
// 	});

// 	$(document).on('click','.JXcategories_back',function() {
// 		var grupa = $(this),
// 		naziv = grupa.data('grupa'),
// 		grupa_pr_id = grupa.data('grupa_pr_id'),
// 		parrent_grupa_pr_id = grupa.data('parrent_grupa_pr_id');
// 		$.post(base_url + 'ajax-categories-back', {grupa: naziv, grupa_pr_id: grupa_pr_id, parrent_grupa_pr_id: parrent_grupa_pr_id}, function (response){
// 			if(response != '') {
// 				$('.header_content').html(response);			
// 			}
// 		})
// 	});
// });

//# sourceMappingURL=header_ajax.min.js.map
